module.exports = __webpack_public_path__ + "img/Romance.3990a925.svg";